<template>
  <v-bottom-navigation
    class="mt-5"
    fixed
    :value="value"
    color="primary"
    grow
    @change="navigate($event)"
  >
    <v-btn :value="route.url" x-large v-for="(route, idx) in routes" :key="idx" >
      <span> {{ route.titulo }} </span>
      <v-icon>
        {{ route.icono }}
      </v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>
<script>
export default {
  name: 'NavBottom',
  data () {
    return {
      value: '/asistencias',
      routes: [
        { url: '/asistencias', titulo: 'Asistencias', icono: 'mdi-hand' },
        { url: '/no-programados', titulo: 'No programados', icono: 'mdi-clipboard-outline' },
        { url: '/mis-asistencias', titulo: 'Mis asistencias', icono: 'mdi-book' }
      ]
    }
  },
  methods: {
    navigate (value) {
      this.$router.push(value)
    }
  },
  mounted () {
    this.value = this.$route.fullPath
  }
}
</script>
